/**
 * Все пути приложения в одном месте.
 * Строковые литералы вроде "/pbam1" больше нигде не повторяются.
 */
export const ROUTES = {
  home: "/",
  organization: "/organization",
  tajikistan: "/tajikistan",
  ifas: "/project",
  activity: "/work",
  publications: "/publication",
  news: "/news",
  newsItem: (id) => `/news/${id}`,
  staticNewsItem: (id) => `/news/static/${id}`,
  reports: "/reports",
  announcements: "/announcements",
  pbam: (slug) => `/${slug}`,
  program: (slug) => `/${slug}`,
};

export default ROUTES;
